import { render } from "./UserRegisterError.vue?vue&type=template&id=04aeceec&scoped=true"
import script from "./UserRegisterError.vue?vue&type=script&lang=js"
export * from "./UserRegisterError.vue?vue&type=script&lang=js"

import "./UserRegisterError.vue?vue&type=style&index=0&id=04aeceec&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04aeceec"]])

export default __exports__